<template>
  <div>
    <PageTable
      hideExport
      hideTitle
      @selection-change="seChoose"
      ref="dataTable"
      :auto-load="true"
      :data="dataTable"
      @load-data="dataTableLoad"
      highlight-current-row
      stripe
      border
    >
      <el-table-column type="selection" align="center"></el-table-column>
      <!--            <el-table-column label="发送配置标识" prop="sconfigdefn" show-overflow-tooltip align="center"></el-table-column>-->
      <el-table-column
        label="接收用户身份(ReceiverId)"
        prop="sreceiverdefn"
        show-overflow-tooltip
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        label="报文类型"
        prop="smsgtype"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        label="本地发送协议"
        prop="ssenderconndefn"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        label="责任链"
        prop="srcdefn"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        label="传输发送协议"
        prop="sreceiverconndefn"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <!-- <el-table-column label="线程数" prop="scscnnum" show-overflow-tooltip width="60"></el-table-column> -->
      <el-table-column label="运行状态" prop="csstatus" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.csstatus === '-1'">初始化失败</el-tag>
          <el-tag v-else-if="row.csstatus === '0'">未初始化</el-tag>
          <el-tag v-else-if="row.csstatus === '1'">初始化成功</el-tag>
          <el-tag v-else-if="row.csstatus === '2'">已启动</el-tag>
          <el-tag v-else-if="row.csstatus === '-2'">已停用</el-tag>
          <el-tag v-else-if="row.csstatus === '-3'">已停止</el-tag>
          <el-tag v-else>初始化</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        show-overflow-tooltip
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            title="编辑"
            class="blue"
            icon="el-icon-fa-edit"
            @click="edit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            title="开始"
            class="green"
            icon="el-icon-fa-play"
            @click="startRes(scope.$index, scope.row)"
            >开始</el-button
          >
          <el-button
            title="开始"
            class="red"
            icon="el-icon-fa-stop"
            @click="stopRes(scope.$index, scope.row)"
            >停止</el-button
          >
        </template>
      </el-table-column>
    </PageTable>
  </div>
</template>
<script>
import idApi from '@/api/senior/idApi.js';
import monitorApi from '@/api/senior/monitorApi';

export default {
  props: {
    senderUuid: '',
  },
  data() {
    return {
      dataTable: [],
      multipleSelection: [],
    };
  },
  methods: {
    seChoose(val) {
      this.multipleSelection = val;
    },
    edit(index, row) {
      console.log('row', row);
      this.$emit('editSend', { row });
    },
    doSeleDel() {
      if (this.multipleSelection.length !== 0) {
        this.$confirm('是否删除该条数据', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let array = [];
          this.multipleSelection.forEach((value, index) => {
            array.push(value.uuid);
          });
          idApi.delSn(array).then(() => {
            this.reload();
            monitorApi
              .select()
              .then((respData) =>
                this.$store.dispatch(
                  'client/loadMonTableData',
                  respData.datarows
                )
              );
          });
        });
      } else {
        this.$message({
          message: '请选择数据！',
          type: 'warning',
        });
      }
    },
    dataTableLoad(params, resole) {
      let str = { ai_uuid: this.senderUuid };
      idApi
        .selectSender(Object.assign(str, params))
        .then(resole)
        .then((respData) => (this.dataTable = respData.datarows));
    },
    reload() {
      this.$refs.dataTable.load();
    },
    startAllSend() {
      let array = [];
      this.dataTable.forEach((value, index) => {
        array.push(value.uuid);
      });
      idApi.identityResStartByuuid(array).then(() => {
        this.$refs.dataTable.load();
      });
    },
    stopAllSend() {
      let array = [];
      this.dataTable.forEach((value, index) => {
        array.push(value.uuid);
      });
      idApi.identityResStopByuuid(array).then(() => {
        this.$refs.dataTable.load();
      });
    },
    startRes(index, row) {
      let array = [];
      array.push(row.uuid);
      idApi.identityResStartByuuid(array).then(() => {
        this.$refs.dataTable.load();
      });
    },
    stopRes(index, row) {
      let array = [];
      array.push(row.uuid);
      idApi.identityResStopByuuid(array).then(() => {
        this.$refs.dataTable.load();
      });
    },
  },
};
</script>
